module.exports = __webpack_public_path__ + "img/Doctor_Consultation.312c8a1d.png";